import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { useDispatch, useSelector } from "react-redux";

import { ReportMenu } from "./reportMenu";


const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const Reports = (props) => {
  const user = useSelector((state) => state.auth);
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  return (
    <>
      {
        <Box 
        // sx={{ display: "flex", }}
        >
          <CssBaseline />
          <Drawer variant="permanent" open={open}
              sx={{
                '& .MuiDrawer-paper': { height: '100%', boxSizing: 'border-box', marginLeft: '250px', backgroundColor: "white",
                  marginTop: '70px' 
                }}}>
            <DrawerHeader
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}><IconButton
      onClick={handleDrawerToggle}
      aria-label={open ? 'Close drawer' : 'Open drawer'}
      title={open ? 'Close drawer' : 'Open drawer'}
    >
      {theme.direction === 'rtl' ? (
        open ? <ChevronRightIcon /> : <ChevronLeftIcon />
      ) : (
        open ? <ChevronLeftIcon /> : <ChevronRightIcon />
      )}
    </IconButton>
    {open && (
        <Typography variant="h5" style={{textAlign: 'center'}}>
          Report
        </Typography>
      )}</div>
              
            </DrawerHeader>
            <Divider />
            <List>
              <ReportMenu />
            </List>
            <Divider />
          </Drawer>
          <Box
            component="main"
            sx={{ flexGrow: 1, p: 3 }}
            style={{ paddingTop: 85 }}
          >
            {props.children}
          </Box>
        </Box>
      }
    </>
  );
};

export default Reports;
